import { XIcon } from 'lucide-react'
import { ScrollArea } from '@/components/ui/scroll-area'
import type { AICreation } from './types'

interface ImageGridProps {
  images: AICreation[]
  onRemove?: (url: string) => void
}

export function ImageGrid({ images, onRemove }: ImageGridProps) {
  return (
    <div className="w-full grid gap-4 max-h-[400px] relative pt-2 pb-2">
      <ScrollArea className="h-full w-full">
        <div className="grid grid-cols-4 gap-4">
          {images.map((img, index) => (
            <div key={img.url} className="relative group">
              <img
                src={img.url}
                alt={`AI Generated ${index + 1}`}
                className="w-full h-auto rounded-lg"
              />
              {/* {img.isSelected && (
                <div className="absolute top-2 right-2 bg-green-500 rounded-full p-1">
                  <CheckCircle2Icon className="w-5 h-5 text-white" />
                </div>
              )} */}
              {onRemove && (
                <button
                  onClick={() => onRemove(img.url)}
                  type="button"
                  className="absolute top-2 right-3 p-1 rounded-full bg-black/50 hover:bg-black/70 transition-all 
                    opacity-0 group-hover:opacity-100"
                  aria-label="Remove image"
                >
                  <XIcon className="w-4 h-4 text-white" />
                </button>
              )}
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  )
}
